module.exports = __webpack_public_path__ + "static/img/usbj2.5560937.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/usbj2.png
// module id = 982
// module chunks = 1